import { render, staticRenderFns } from "./novaContaBlueSend.vue?vue&type=template&id=53be6c13"
import script from "./novaContaBlueSend.vue?vue&type=script&lang=js"
export * from "./novaContaBlueSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports